import { CategoryType, UserLoginType } from "@/DTO";
import { Api } from "@/api";

export const getCategory = (user: UserLoginType, id: string,name: string = "") => {
  return new Promise<{ data: CategoryType }>((resolve, reject) => {
    const api = new Api({
      method: "get",
      path: `category/${id}`,
      header: {
        Authorization: "Bearer " + user?.accessToken,
      },
      params: {
        name: name
      }
    });
    return api
      .call()
      .then((data) => {
        return resolve({
          data: convertCategory(data),
        });
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

export const convertCategory = (data: any): CategoryType => {
  return data;
};
